import { syncMutationResponse } from './dataSync';
import { readSessionKey } from './queryCache';
import { ECOMMERCE_API_BASE_URL,shippingLabelEndpointPrefix } from '../config';
export type RequestTiming = {method:string; path:string; status:number; durationMs:number};
const timings:RequestTiming[]=[];
/** Development diagnostics omit query strings, bodies, headers and credentials. */
export const getRequestTimings=():readonly RequestTiming[]=>timings.map(item=>({...item}));

/** All business HTTP uses this boundary. Auth and response schemas stay in domain adapters.
 * Forward cancellation, cookies, multipart and streams unchanged. Never replay a request.
 */
export async function httpFetch(input:RequestInfo|URL, init?:RequestInit):Promise<Response> {
    const started=performance.now();let status=0;
    const session=readSessionKey();
    try {
        const response=await fetch(input,init);status=response.status;
        const request=typeof Request!=='undefined' && input instanceof Request ? input : undefined;
        const target=request?.url ?? String(input);
        const url=new URL(target,window.location.origin);
        const owned=[ECOMMERCE_API_BASE_URL,shippingLabelEndpointPrefix].filter(Boolean).some(base=>{
            const endpoint=new URL(base!,window.location.origin);
            return endpoint.origin===url.origin && (url.pathname===endpoint.pathname || url.pathname.startsWith(endpoint.pathname.replace(/\/$/,'')+'/'));
        }) || (url.origin===window.location.origin && /^\/api\/(?:ecommerce|labeling)(?:\/|$)/.test(url.pathname));
        if(owned && response.status>=200 && response.status<300 && !['GET','HEAD','OPTIONS'].includes((init?.method??request?.method??'GET').toUpperCase()) && session===readSessionKey()){
            try{await syncMutationResponse(target,{...init,method:init?.method??request?.method??'GET'},response,session);}
            catch(error){console.error('Data synchronization failed',error);}
        }
        return response;
    } finally {
        if(process.env.NODE_ENV==='development') {
            try {
                const request=typeof Request!=='undefined' && input instanceof Request ? input : undefined;
                const url=new URL(request?.url ?? String(input),window.location.origin);
                timings.push({method:(init?.method ?? request?.method ?? 'GET').toUpperCase(),
                    path:url.pathname.replace(/\/\d+(?=\/|$)/g,'/:id'),status,durationMs:performance.now()-started});
                if(timings.length>200)timings.shift();
            } catch { /* Diagnostics must never change a business result. */ }
        }
    }
}
